import React from "react";
import Detail from "./Detail";

export default function DetailIndex() {
    return <Detail />;
}
